import { useEffect } from "react";

/**
 * Sums all input values inside divs with class 'fw_total' and sets
 * the summed value in the input inside the div with class 'fw_total_sum'.
 */
export const useSakuraTotalSum = (domId, className, id, setValue) => {
  const totalType = domId?.split("_")[0] || className?.split("_")[0] || null;
  if (!totalType) return;
  useEffect(() => {
    const sumAndSet = () => {
      const total = Array.from(
        document.querySelectorAll<HTMLDivElement>(
          `div.${totalType}_total > input`,
        ),
      ).reduce((acc, input) => {
        const val = parseFloat(String(input.value).replace(",", "."));
        return acc + (isNaN(val) ? 0 : val);
      }, 0);

      if (domId === `${totalType}_total_sum`) {
        // Defer setValue to prevent interfering with tab navigation
        setTimeout(() => {
          setValue(id, total ? total.toString() : "");
        }, 0);
      }
    };

    sumAndSet(); // initial sum

    // Attach blur event listeners on all inputs inside div.fw_total
    const inputs = Array.from(
      document.querySelectorAll<HTMLInputElement>(
        `div.${totalType}_total > input`,
      ),
    );
    inputs.forEach(input => input.addEventListener("blur", sumAndSet));

    return () => {
      inputs.forEach(input => input.removeEventListener("blur", sumAndSet));
    };
  }, []);
};
